import { jsx } from 'react/jsx-runtime';
import events from 'events-bus';
import { createContext, useState, useEffect, useContext } from 'react';
import { initAxios, syncToken } from '../services/api.js';

const KeycloakTokenContext = createContext({
    tokenPayload: {
        sid: undefined,
    },
});
const useKeycloakTokenProvider = () => useContext(KeycloakTokenContext);
const KeycloakTokenProvider = ({ allowedUrls = [], children, }) => {
    const [keycloakTokenLoaded, setKeycloakTokenLoaded] = useState(false);
    const [tokenPayload, setTokenPayload] = useState(undefined);
    useEffect(() => {
        initAxios(allowedUrls);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getToken = () => {
        const frontendAuthorizerConfig = window.frontendAuthorizerConfig;
        if (frontendAuthorizerConfig?.tokenPayload?.customerId) {
            syncToken(frontendAuthorizerConfig.token);
            setKeycloakTokenLoaded(frontendAuthorizerConfig.token);
        }
        if (frontendAuthorizerConfig?.tokenPayload) {
            setTokenPayload(frontendAuthorizerConfig?.tokenPayload);
        }
    };
    useEffect(() => {
        getToken();
        const tokenListener = (_, data) => {
            const token = data.token;
            syncToken(token);
            setKeycloakTokenLoaded(!!token);
            if (data.payload) {
                setTokenPayload(data.payload);
            }
        };
        events.on('AUTH-SUCCESS-EVENT-v1', tokenListener);
        return () => {
            events.off(tokenListener);
        };
    }, []);
    if (!keycloakTokenLoaded) {
        return null;
    }
    return (jsx(KeycloakTokenContext.Provider, { value: { tokenPayload }, children: children }));
};

export { KeycloakTokenContext, KeycloakTokenProvider as default, useKeycloakTokenProvider };
//# sourceMappingURL=KeycloakTokenProvider.js.map
